import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7b47c0b8"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nav"
}, [/*#__PURE__*/_createElementVNode("strong", null, "卡册图鉴")], -1));
const _hoisted_2 = ["onClick"];
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "name"
};
const _hoisted_5 = {
  class: "progress"
};
const _hoisted_6 = {
  class: "words"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_list = _resolveComponent("van-list");
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", {
    class: _normalizeClass(['collect-box render-hide-scroll', {
      'collect-box-wx': $data.env.isWxApp()
    }])
  }, [_hoisted_1, _createVNode(_component_van_list, {
    loading: $data.loading,
    "onUpdate:loading": _cache[0] || (_cache[0] = $event => $data.loading = $event),
    finished: $data.finished,
    "finished-text": "没有更多了",
    onLoad: $options.getList
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, item => {
      return _openBlock(), _createElementBlock("div", {
        key: item,
        class: "collect-item",
        onClick: $event => $options.goUserCollect(item.id)
      }, [_createElementVNode("img", {
        class: "img",
        src: `${_ctx.$imgUrlFilter(item.list_main_image_url, 1280)}`
      }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
        class: "percent",
        style: _normalizeStyle(`width: calc(${item.user_collect_number / item.card_number} * 100%)`)
      }, null, 4), _createElementVNode("div", _hoisted_6, "已收集 " + _toDisplayString(item.user_collect_number) + " / " + _toDisplayString(item.card_number), 1)])], 8, _hoisted_2);
    }), 128))]),
    _: 1
  }, 8, ["loading", "finished", "onLoad"]), !$data.env.isWxApp() ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "back",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.goBack && $options.goBack(...args))
  })) : _createCommentVNode("", true)], 2)]);
}